import { render, staticRenderFns } from "./automations.vue?vue&type=template&id=39187ca2&scoped=true"
import script from "./automations.vue?vue&type=script&lang=js"
export * from "./automations.vue?vue&type=script&lang=js"
import style0 from "./automations.vue?vue&type=style&index=0&id=39187ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39187ca2",
  null
  
)

export default component.exports